
import {vec3 as vec3_} from '../utils/matrix';
import MapSurfaceTile_ from './surface-tile';

//get rid of compiler mess
var vec3 = vec3_;
var MapSurfaceTile = MapSurfaceTile_;


var MapSurfaceTree = function(map, freeLayer, freeLayerSurface) {
    this.map = map;
    this.rootId = [0,0,0];
    this.freeLayer = freeLayer;
    this.freeLayerSurface = freeLayerSurface;
    this.metaBinaryOrder = this.map.referenceFrame.params.metaBinaryOrder;
    //this.initialized = false;
    //this.geocent = !this.map.getNavigationSrs().isProjected();

    this.surfaceTree = new MapSurfaceTile(this.map, null, this.rootId);

    //if (freeLayer !== true) {
    //}

    this.config = this.map.config;
    this.cameraPos = [0,0,0];
    this.worldPos = [0,0,0];
    this.counter = 0;
};


MapSurfaceTree.prototype.kill = function() {
    this.surfaceTree = null;
    this.metastorageTree = null;
    this.surfaceTracer = null;
};


/*MapSurfaceTree.prototype.init = function() {
    var url = this.map.url.makeUrl(surface.metaUrl, {lod:result[0], ix:result[1], iy:result[2] });  //result???
    map.loader.load(url, metatile.load.bind(metatile, url));

    this.metatileTree.load();
    this.surfaceTree.metatile = 1;

    this.initialized = true;
};*/


MapSurfaceTree.prototype.findSurfaceTile = function(id) {
    var tile = this.surfaceTree;

//    for (var lod = 1; lod <= id[0]; lod++) {
//        var mask = 1 << (lod-1);
//        var index = 0;

    for (var lod = id[0]; lod > 0; lod--) {
        var mask = 1 << (lod-1);
        var index = 0;

        if ((id[1] & mask) != 0) {
            index += 1;
        }

        if ((id[2] & mask) != 0) {
            index += 2;
        }

        tile = tile.children[index];

        if (!tile) {
            return null;
        }
    }

    return tile;
};



MapSurfaceTree.prototype.draw = function() {
    this.cameraPos = [0,0,0];
    this.worldPos = [0,0,0];

    var map = this.map;
    var draw = map.draw;

    var srs = map.getPhysicalSrs();

    //var divisionNode = this.divisionNode;
    var periodicity = srs.periodicity;

    //if (this.map.config.mapBasicTileSequence) {
        //this.surfaceTracer = this.surfaceTracerBasic;
    //}

    // Terrain now draws through the recursive traversal on the typed
    // Map. This legacy tree is reached only by tiled-geodata free
    // layers, which use the fitted-frontier traversal to collect their
    // geodata jobs. Non-geodata free layers are not rendered: both
    // free-layer sequence builders skip them (see Map.refreshFreelayes-
    // InView and the style-based equivalent).
    this.drawSurfaceFit([0,0,0]);

    if (periodicity != null && periodicity.type == 'X') {
        this.drawSurfaceFit([periodicity.period,0,0]);
        this.drawSurfaceFit([-periodicity.period,0,0]);
    }
};


MapSurfaceTree.prototype.logTileInfo = function(tile, node, cameraPos) {
    if (!tile || !node) {
        return;
    }

    var visible = tile.bboxVisible(tile.id, cameraPos, node);
    tile.updateTexelSize();

    // eslint-disable-next-line
    console.log('tile: ' + JSON.stringify(tile.id) + ' visible: ' + visible + ' texelsize: ' +  tile.texelSize + ' center: '  + JSON.stringify(node.diskPos) + ' vec: ' + node.diskNormal + 'ang: ' + node.diskAngle + ' dist: ' + node.diskDistance);
};


//loadmode = fit
MapSurfaceTree.prototype.drawSurfaceFit = function(shift) {
    this.counter++;

    var tile = this.surfaceTree;

    if (!tile.isMetanodeReady(this, 0)) {
        return;
    }

    var map = this.map;
    var node = tile.metanode;
    var cameraPos = map.outerMap.selectionCamera.geometry.eye;

    // a tile carrying a placed label that reaches into the canvas is
    // drawn with its box outside the view; see `LabelPlacement`
    var placement = map.renderer.labelPlacement;
    var layer = this.freeLayerSurface.id;

    if (!tile.bboxVisible(tile.id, cameraPos, node)
            && !(placement && placement.carriesPlaced(layer, tile.id)))
        return;

    tile.updateTexelSize();

    var geodata = tile.surface ? tile.surface.geodata : null;
    var maxLod = tile.surface.lodRange[1];
    var checkGpu = true;

    var lodShift = 4;//this.freeLayerSurface ? 1 : 1;
    var typeFactor = 2000;//this.freeLayerSurface ? 1 : 1;

    if (this.freeLayerSurface) {
        lodShift = 0;//this.freeLayerSurface ? 1 : 1;
        typeFactor = 0.1;//this.freeLayerSurface ? 1 : 1;
    }

    var draw = map.draw;
    var drawTiles = draw.drawTiles;
    var drawBuffer = draw.drawBuffer;
    var processBuffer = draw.processBuffer;
    var newProcessBuffer = draw.processBuffer2;
    var drawBufferIndex = 0;
    var processBufferIndex = 0;
    var newProcessBufferIndex = 0;

    processBuffer[0] = [tile, 0];
    processBufferIndex = 1;

    var texelSizeFit = map.config.mapTexelSizeFit;

    draw.drawCounter++;

    var usedNodes = 1;
    var pocessedNodes = 1;
    var pocessedMetatiles = 1;
    var drawCounter = draw.drawCounter;
    var maxHiresLodLevels = map.config.mapMaxHiresLodLevels, i, j, lj, child, priority, parent, parent2, children2;

    do {
        var best = 0;
        newProcessBufferIndex = 0;

        /*if (this.map.drawIndices) {
            console.log("processed begin==============================================");
        }*/

        for (i = processBufferIndex - 1; i >= 0; i--) {
            var pack = processBuffer[i];
            tile = pack[0];
            var depth = pack[1];

            tile.childrenReadyCount = 0;

            /*if (this.map.drawIndices) {
                console.log(JSON.stringify(tile.id));
            }*/

            if (depth >= maxHiresLodLevels) {
                continue;
            }

            node = tile.metanode;

            if (node) {
                pocessedNodes++;
                if (node.metatile.drawCounter != drawCounter) {
                    node.metatile.drawCounter = drawCounter;
                    pocessedMetatiles++;
                }
            }


            if (tile.bboxVisible(tile.id, cameraPos, node)
                || (placement && placement.carriesPlaced(layer, tile.id))) {

                usedNodes++;

                if (tile.texelSize  != Number.POSITIVE_INFINITY){
                    if (tile.texelSize > best) {
                        best = tile.texelSize;
                    }
                }

                var lastProcessBufferIndex = newProcessBufferIndex;
                var lastDrawBufferIndex = drawBufferIndex;

                if (!node.hasChildren() || tile.texelSize <= texelSizeFit || (geodata && tile.id[0] >= maxLod)) {

                    priority = ((tile.id[0] + lodShift) * typeFactor) * tile.distance;

                    if (node.hasChildren() && !drawTiles.drawSurfaceTile(tile, tile.metanode, cameraPos, tile.texelSize, priority, true, (depth > 0), checkGpu)) {

                        depth++; //we dont have tile ready, so we try to draw more detailed tiles

                        for (j = 0; j < 4; j++) {
                            child = tile.children[j];
                            if (child) {

                                if (child.isMetanodeReady(this, child.id[0], true)) { //lod is used as priority

                                    child.updateTexelSize();

                                    //are draw buffers ready? preventRender=true, preventLoad=false
                                    if (drawTiles.drawSurfaceTile(child, child.metanode, cameraPos, child.texelSize, priority, true, (depth > 0), checkGpu)) {
                                        tile.childrenReadyCount++;
                                        child.drawCounter = draw.drawCounter;

                                        drawBuffer[drawBufferIndex] = [child, false];
                                        drawBufferIndex++;
                                    } else {
                                        newProcessBuffer[newProcessBufferIndex] = [child, depth];
                                        newProcessBufferIndex++;
                                    }
                                }
                            }
                        }

                        if (lastProcessBufferIndex == newProcessBufferIndex && lastDrawBufferIndex == drawBufferIndex) {
                            depth--;
                        }

                    } else {
                        tile.drawCounter = draw.drawCounter;

                        drawBuffer[drawBufferIndex] = [tile, false];
                        drawBufferIndex++;
                    }

                } else if (depth == 0 && node.hasGeometry() && tile.texelSize <= (texelSizeFit * 2)) {

                    //are all children ready? if not then draw carser lod
                    var childrenCount = 0;
                    var readyCount = 0;
                    var childrenBuffer = [];

                    for (j = 0; j < 4; j++) {
                        child = tile.children[j];
                        if (child) {
                            childrenCount++;

                            if (child.isMetanodeReady(this, child.id[0])) { //lod is used as priority

                                child.updateTexelSize();

                                priority = ((child.id[0] + lodShift) * typeFactor) * child.distance;

                                //are draw buffers ready? preventRender=true, preventLoad=true
                                if (drawTiles.drawSurfaceTile(child, child.metanode, cameraPos, child.texelSize, priority, true, true, checkGpu)) {
                                    readyCount++;
                                    childrenBuffer.push(child);
                                }
                            }
                        }
                    }

                    if (childrenCount > 0 && childrenCount == readyCount) {
                        //sort children by distance

                        do {
                            var sorted = true;

                            for (j = 0, lj = childrenBuffer.length - 1; j < lj; j++) {
                                if (childrenBuffer[j].distance > childrenBuffer[j+1].distance) {
                                    var t = childrenBuffer[j];
                                    childrenBuffer[j] = childrenBuffer[j+1];
                                    childrenBuffer[j+1] = t;
                                    sorted = false;
                                }
                            }

                        } while(!sorted);

                        //add children to new process buffer
                        for (j = 0, lj = childrenBuffer.length; j < lj; j++) {
                            newProcessBuffer[newProcessBufferIndex] = [childrenBuffer[j], depth];
                            newProcessBufferIndex++;
                        }
                    } else {

                        //can i use coarser lod
                        priority = ((tile.id[0] + lodShift) * typeFactor) * tile.distance;

                        if (drawTiles.drawSurfaceTile(tile, tile.metanode, cameraPos, tile.texelSize, priority, true, true, checkGpu)) {
                            tile.drawCounter = draw.drawCounter;

                            drawBuffer[drawBufferIndex] = [tile, false];
                            drawBufferIndex++;

                            for (j = 0; j < 4; j++) {
                                child = tile.children[j];
                                if (child) {
                                    if (child.isMetanodeReady(this, child.id[0])) { //lod is used as priority
                                        priority = ((child.id[0] + lodShift) * typeFactor) * child.distance;
                                        drawTiles.drawSurfaceTile(child, child.metanode, cameraPos, child.texelSize, priority, true, false, checkGpu);
                                    }
                                }
                            }

                        } else {

                            //add children to new process buffer
                            for (j = 0; j < 4; j++) {
                                child = tile.children[j];
                                if (child) {
                                    if (child.isMetanodeReady(this, child.id[0])) { //lod is used as priority
                                        child.updateTexelSize();

                                        newProcessBuffer[newProcessBufferIndex] = [child, depth];
                                        newProcessBufferIndex++;
                                    }
                                }
                            }

                        }
                    }

                }  else  {  //go deeper


                    for (j = 0; j < 4; j++) {
                        child = tile.children[j];
                        if (child) {

                            if (child.isMetanodeReady(this, child.id[0])) { //lod is used as priority
                                child.updateTexelSize();

                                newProcessBuffer[newProcessBufferIndex] = [child, depth];
                                newProcessBufferIndex++;
                            }
                        }
                    }
                }
            }

        }

        /*if (this.map.drawIndices) {
            console.log("processed end==============================================");
        }*/

        var tmp = processBuffer;
        processBuffer = newProcessBuffer;
        newProcessBuffer = tmp;
        processBufferIndex = newProcessBufferIndex;

    } while(processBufferIndex > 0);

    var stats = map.stats;

    stats.usedNodes = usedNodes;
    stats.processedNodes = pocessedNodes;
    stats.processedMetatiles = pocessedMetatiles;

    this.processDrawBuffer(draw, drawTiles, cameraPos, map, stats, drawBuffer, drawBufferIndex);
};


MapSurfaceTree.prototype.processDrawBuffer = function(draw, drawTiles, cameraPos, map, stats, drawBuffer, drawBufferIndex) {

    var scanExtents = (!this.freeLayerSurface && map.config.mapFeatureStickMode[0] == 2);
    var hmax = -999999, hmin = 999999;
    var renderer = map.renderer;
    var p1, p2, camVec, length, tilt, factor, i, tile, node;
    var camera = renderer.mapCamera;
    var halfWidth = renderer.apparentSize[0] * 0.5;

    map.gpuCache.skipCostCheck = true;

    var drawSelectedBuffer = function(drawCameraPos) {

        //draw surface
        for (i = drawBufferIndex - 1; i >= 0; i--) {
            var item = drawBuffer[i];
            tile = item[0];
            node = tile.metanode;

            if (scanExtents && node) {

                // TODO noramlize by distance and tilt

                p2 = node.diskPos;
                p1 = renderer.mapCamera.geometry.eye;
                camVec = [p2[0] - p1[0], p2[1] - p1[1], p2[2] - p1[2]];
                length = vec3.normalize4(camVec);
                tilt = -vec3.dot(camVec, node.diskNormal);

                if (tilt < 0) {
                    tilt = 0;
                }

                tilt = 1 - tilt;

                // pixels per metre at the node, times the tilt
                factor = camera.ndcUnitPerViewUnitAtDistance(length)
                    * halfWidth * tilt;
                //renderer.camera.scaleFactor2(d) * screenPixelSize
                //pp = this.renderer.project2(tile.diskPos, mvp);

                if (node.minZ * factor < hmin) {
                    hmin = node.minZ * factor;
                }

                if (node.maxZ * factor > hmax) {
                    hmax = node.maxZ * factor;
                }
            }


            if (stats.gpuRenderUsed >= draw.maxGpuUsed) {

                // out of GPU budget this frame; show bbox info if
                // requested and skip the tile
                if (drawTiles.map.outerMap.overrides.drawBBoxes) {
                    drawTiles.drawTileInfo(
                        tile, tile.metanode, drawCameraPos);
                }

            } else {
                drawTiles.drawSurfaceTile(
                    tile, tile.metanode, drawCameraPos,
                    tile.texelSize, 0, false, false);
            }
        } // for (i = drawBufferIndex - 1; i >= 0; i--)
    };

    drawSelectedBuffer(map.outerMap.camera.geometry.eye);

    if (scanExtents) {
        renderer.gridHmax = hmax;
        renderer.gridHmin = hmin;
    }

    map.gpuCache.skipCostCheck = false;
    map.gpuCache.checkCost();

};



MapSurfaceTree.prototype.getNodeById = function(id, preventLoad) {
    var tile = this.surfaceTree;

    if (tile == null) {
        return;
    }

    for (var lod = id[0]; lod > 0; lod--) {
        var mask = 1 << (lod-1);
        var index = 0;

        if ((id[1] & mask) != 0) {
            index += 1;
        }

        if ((id[2] & mask) != 0) {
            index += 2;
        }

        if (!tile.children[index]) {

            if (!tile.isMetanodeReady(this, 0, preventLoad)) {
                return null;
            }

            if (!tile.metanode.hasChild(index)) {
                return null;
            }

            tile.addChild(index);
        }

        tile = tile.children[index];
    }

    if (!tile) {
        return;
    }

    if (!tile.isMetanodeReady(this, 0, preventLoad)) {
        return;
    }

    var node = tile.metanode;
    tile.metanode.metatile.used();

    return node;

	/*
    if (tile.lastSurface && tile.lastSurface == tile.surface) {
        tile.lastSurface = null;
        tile.restoreLastState();
        //return;
    }*/
};


MapSurfaceTree.prototype.getRenderedNodeById = function(id, drawCounter) {
    var tile = this.surfaceTree;

    if (tile == null) {
        return;
    }

    if (tile.drawCounter == drawCounter) {
        if (!tile.isMetanodeReady(this, 0)) {
            return;
        }

        return tile.metanode;
    }

    for (var lod = id[0]; lod > 0; lod--) {
        var mask = 1 << (lod-1);
        var index = 0;

        if ((id[1] & mask) != 0) {
            index += 1;
        }

        if ((id[2] & mask) != 0) {
            index += 2;
        }

        if (!tile.children[index]) {

            if (!tile.isMetanodeReady(this, 0)) {
                return;
            }

            if (!tile.metanode.hasChild(index)) {
                return;
            }
        }

        tile = tile.children[index];

        if (tile.drawCounter == drawCounter) {
            if (!tile.isMetanodeReady(this, 0)) {
                return;
            }

            return tile.metanode;
        } else {
            if (lod == 1) { //rendered lod is probably from more detailed lod so we take one which is from same lod
                return tile.metanode;
            }
        }
    }

    return;
};


export default MapSurfaceTree;
